module.exports = __webpack_public_path__ + "static/img/9.0a67fb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/9.png
// module id = RndZ
// module chunks = 0